import LogEventDetailsPanelTabs from 'automation-ui-log-events/constants/LogEventDetailsPanelTabs';
import basePaths from 'automation-ui-routing/BasePaths';
import { getFlowDetailsRoute } from 'automation-ui-routing/utils';
export const logEventDetailsPanelUEPath = (pageBasePath, idempotencyId, tab) => {
  const tabPath = tab || LogEventDetailsPanelTabs.DETAILS;
  return `${pageBasePath}/${basePaths.EVENT}/by-id/${idempotencyId}/${tabPath}`;
};
export const listBranchDebugPanelPath = (pageBasePath, idempotencyId) => {
  return `${pageBasePath}/${basePaths.BRANCH_DIAGNOSE}/by-id/${idempotencyId}`;
};
export const enrollmentDetailsPanelPath = (flowId, enrollmentId, objectId) => {
  return `${getFlowDetailsRoute(flowId, basePaths.ENROLLMENTS)}/${basePaths.ENROLLMENT_DETAILS}/${enrollmentId}/${objectId}`;
};
export const enrollmentDiagnosePath = (flowId, enrollmentId) => {
  return `${getFlowDetailsRoute(flowId, basePaths.ENROLLMENTS)}/${basePaths.ENROLLMENT_DIAGNOSE}/${enrollmentId}`;
};